// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-swiper[data-v-bc9d3b70] .swiper-wrapper{padding-bottom:3rem}.custom-swiper[data-v-bc9d3b70] .swiper-wrapper .swiper-slide{padding:0 6rem;box-sizing:border-box}@media(max-width:800px){.custom-swiper[data-v-bc9d3b70] .swiper-wrapper .swiper-slide{padding:0 4rem}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
